"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EPIC_END = void 0;
var EPIC_END = '@@redux-observable/EPIC_END';
exports.EPIC_END = EPIC_END;